<app-modal-v2 #modal customClassName="patient-ediary-entry-modal">
  <div class="modal-content">

    <div class="modal-header">
      <h2 class="modal-title">
        {{ isBusy ? 'Loading...' : (editable ? 'Edit E-Diary Entry' : 'E-Diary Entry') }}
      </h2>
    </div>

    <div class="modal-body">

      <div class="questions-container" *ngIf="!editable && entry && !isBusy">
        <div class="question" *ngFor="let question of entry.questions">
          <div class="question-label">{{ question.questionLabel }}</div>
          <div class="question-answer-container">
            <div class="question-answers" *ngFor="let answer of question.answers">
              <span [innerHTML]="answer.value | replaceNewLines"></span>
            </div>
          </div>
        </div>
      </div>

      <form class="questions-container" *ngIf="editable && editForm && formReady && !isBusy" [formGroup]="form">
        <div class="question" *ngFor="let question of editForm.questions">
          <div class="question-label">{{ question.label }}
            @if (question.isRequired) {
              <span class="required">*</span>
            }
          </div>

          <ng-container [ngSwitch]="question.type">
            <div *ngSwitchCase="'Radio'" class="option-list">
              <div class="radio-button-container" *ngFor="let option of question.options">
                <label class="radio-button">
                  <input type="radio"
                         [value]="option.id"
                         [name]="question.questionId"
                         [formControlName]="question.questionId"
                         (change)="onSingleAnswerChange(question, option.id)">
                  <span></span>
                </label>
                <span class="option-label">{{ option.text }}</span>
              </div>
            </div>

            <div *ngSwitchCase="'Checkbox'" class="option-list" [formArrayName]="question.questionId">
              <div class="checkbox-wrap" *ngFor="let option of question.options; let i = index">
                <label class="checkbox" [ngClass]="{'checked': (form.get(question.questionId)?.value?.[i] === true)}">
                  <input type="checkbox" [formControlName]="i">
                  <span></span>
                </label>
                <span class="checkbox-label">{{ option.text }}</span>
              </div>
            </div>

            <div *ngSwitchCase="'Dropdown'">
              <app-dropdown-input
                [options]="dropdownOptions(question.questionId)"
                [parentForm]="form"
                [name]="question.questionId"
                [selectedValue]="form.get(question.questionId)?.value"
                (selectValueChanged)="onSingleAnswerChange(question, $event)"
                placeholder="Select...">
              </app-dropdown-input>
            </div>

            <div *ngSwitchCase="'Numeric'">
              <input class="form-control" type="number" [formControlName]="question.questionId" [placeholder]="question.placeholder">
            </div>

            <div *ngSwitchCase="'MultiLineText'">
              <textarea class="form-control" rows="3" [formControlName]="question.questionId" [placeholder]="question.placeholder"></textarea>
            </div>

            <div *ngSwitchCase="'Date'">
              <input class="form-control" type="date" [formControlName]="question.questionId">
            </div>

            <div *ngSwitchCase="'Time'">
              <input class="form-control" type="time" [formControlName]="question.questionId">
            </div>

            <div *ngSwitchDefault>
              <input class="form-control" type="text" [formControlName]="question.questionId" [placeholder]="question.placeholder">
            </div>
          </ng-container>
        </div>
      </form>

      <div class="text-center py-4" *ngIf="isBusy">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </div>

    </div>

    <div class="modal-footer modal-footer-buttons" *ngIf="editable">
      <button type="button" class="btn btn-outline" (click)="modal.hide()">Cancel</button>
      <button type="button" class="btn btn-primary"
              [disabled]="isSaveDisabled() || isSaving"
              (click)="onSave()">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!isSaving">Save</span>
      </button>
    </div>
  </div>
</app-modal-v2>
